export { AlternatingSplashes } from "./AlternatingSplashes"
